import axios from "axios";
const apiUrl =  process.env.NODE_ENV !== 'production' ? 
            process.env.REACT_APP_BASE_DEV_URL :
                process.env.REACT_APP_BASE_PROD_URL

const baseUrl = `${apiUrl}/${process.env.REACT_APP_VERSION}`

export const getCountries = async () => {
    const response = await axios.get(`${baseUrl}/generic/locations/countries`);
    return response.data;
}

export const getStatesByCountry = async (countryId) => {
    const response = await axios.get(`${baseUrl}/generic/locations/states/${countryId}`);
    return response.data;
}

export const getCitiesByState = async (stateId) => {
    const response = await axios.get(`${baseUrl}/generic/locations/cities/${stateId}`);
    return response.data;
}